import { datadogRum } from '@datadog/browser-rum'
import type { AnalyticsEventProperties } from '../analytics/analytics-types'
import { logAmplitudeEvent } from './useAmplitude'

type AnalyticsEvent = string

export const trackAnalyticsEvent = (action: AnalyticsEvent, properties?: AnalyticsEventProperties) => {
  datadogRum.addAction(action, {
    value: 1
  })
  logAmplitudeEvent(action, properties)
}
